import { render, staticRenderFns } from "./ot-coming-soon.vue?vue&type=template&id=34c2c4ec&scoped=true&"
import script from "./ot-coming-soon.vue?vue&type=script&lang=ts&"
export * from "./ot-coming-soon.vue?vue&type=script&lang=ts&"
import style0 from "./ot-coming-soon.vue?vue&type=style&index=0&id=34c2c4ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c2c4ec",
  null
  
)

export default component.exports